module.exports = __webpack_public_path__ + "static/media/Logo.e3286ab3.png";